export default (ScratchBlocks) => {

    ScratchBlocks.Blocks.jmd_getMaiVoice = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_E7_GETINMIC,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.jmd_getChangeValue = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_BATTERY,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.jmd_getRcuTime = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_getRcuTime,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }
    ScratchBlocks.Blocks.jmd_setRcuTimeTo0 = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_RESETCONTROLLTIME,
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }

    ScratchBlocks.Blocks.E7_jmd_getData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_GETDATAVALUE,
                args1: [{
                    type: "input_value",
                    name: "ADDRESS"
                }],
                category: ScratchBlocks.Categories.jmd,
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.E7_jmd_setData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_SETDATAVALUE,
                args1: [{
                    type: "input_value",
                    name: "ADDRESS"
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.jmd,
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_jmd_setSaveStudyDataToFile = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_SAVEDATATOFILE,
                args1: [{
                    type: "input_value",
                    name: "DATA"
                }, {
                    type: "input_value",
                    name: "NAME",
                }],
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }
    ScratchBlocks.Blocks.E7_jmd_setDeleteStudyFile = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_DELETEFILE,
                args1: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }
    ScratchBlocks.Blocks.E7_jmd_setShowFileData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_SHOWFILEDATA,
                args1: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }

    ScratchBlocks.Blocks.E7_jmd_savePic = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_savePic,
                args1: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }
    ScratchBlocks.Blocks.E7_setEditView = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_setEditView,
                args1: [{
                    type: "input_value",
                    name: "LEFTMARGIN",
                }, {
                    type: "input_value",
                    name: "RIGHTMARGIN",
                }, {
                    type: "input_value",
                    name: "MESSAGE",
                }],
                colour: '#00afae',
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }
    ScratchBlocks.Blocks.E7_getEditViewData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_getEditViewData,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.E7_GetHRCUName = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_GetHRCUName,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.E7_GetCcrrentDate = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_GetCcrrentDate,
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.E7_SetSaveStrToFile = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_SetSaveStrToFile,
                args1: [{
                    type: "input_value",
                    name: "STRING"
                }, {
                    type: "input_value",
                    name: "FILENAME"
                }],
                colour: '#00afae',
                extensions: ["shape_statement"]
            })
        }
    }


    ScratchBlocks.Blocks.E7_GetStrForFile = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.JMD_GetStrForFile,
                args1: [{
                    type: "input_value",
                    name: "FILENAME"
                }, {
                    type: "input_value",
                    name: "LINENUM"
                }],
                colour: '#00afae',
                extensions: ["output_number"]
            })
        }
    }



    ScratchBlocks.Blocks.E7_motor_getMotorCode = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_getMotorCode,
                args1: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_motor_getMotorAngle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_getMotorAngle,
                args1: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_motor_getMotorV = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_getMotorV,
                args1: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.motor_setMotor_E7 = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_setMotor,
                args1: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE",
                }],
                colour: "#c19e61",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.E7_motor_setMotorCode = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_setMotorCode,
                args1: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.motor_stopMotor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_MOTORSTOP,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                colour: "#c19e61",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.motor_setMotorVByOther = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_SETMOTORVBYOTHER,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }, {
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.MOTOR_ARG_CIRCLE, "圈"],
                        [ScratchBlocks.Msg.MOTOR_ARG_DEGREE, "度"],
                        [ScratchBlocks.Msg.MOTOR_ARG_SECONDS, "秒"]
                    ]
                }],
                colour: "#c19e61",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.motor_waitMotorTo = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_WAITMOTORTO,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }, {
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.MOTOR_ARG_CIRCLE, "圈"],
                        [ScratchBlocks.Msg.MOTOR_ARG_DEGREE, "度"],
                        [ScratchBlocks.Msg.MOTOR_ARG_SECONDS, "秒"]
                    ]
                }],
                colour: "#c19e61",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.motor_setSteeringAngle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.MOTOR_setSteeringAngle,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }, {
                    type: "input_value",
                    name: "TIME"
                }, {
                    type: "field_dropdown",
                    name: "DIRECTION",
                    options: [
                        [ScratchBlocks.Msg.MOTOR_ARG_shortest, "最短路径"],
                        [ScratchBlocks.Msg.MOTOR_ARG_clockwise, "顺时针"],
                        [ScratchBlocks.Msg.MOTOR_ARG_anticlockwise, "逆时针"]
                    ]
                }],
                colour: "#c19e61",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.motor_setMotorPowerIs = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: "%1 %2 上电复位",
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        ["开", "1"],
                        ["关", "0"],
                    ]
                }],
                colour: "#c19e61",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };



    // H-RCU(E7)
    // 运动模块
    ScratchBlocks.Blocks.hrcu_motion_setStartMotorLorR = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_SETSTARTMOTORLOR,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT_TWO",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ],
                    defaultItem: 1
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_motion_setMotorByPercent = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_SETMOTORBYPERCENT,
                args1: [{
                    type: "input_value",
                    name: "LEFTVALUE"
                }, {
                    type: "input_value",
                    name: "RIGHTVALUE"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_motion_waitMotorByPercent = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_WAITMOTORBYPERCENT,
                args1: [{
                    type: "input_value",
                    name: "LEFTVALUE"
                }, {
                    type: "input_value",
                    name: "RIGHTVALUE"
                }, {
                    type: "input_value",
                    name: "NUM"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_motion_setMotorsByTime = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_setMotorsByTime,
                args1: [{
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "TIME"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_motion_setMotors = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_setMotors,
                args1: [{
                    type: "input_value",
                    name: "SPEED"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_motion_setMotorsByLength = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_setMotorsByLength,
                args1: [{
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "LENGTH"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_motion_setMotorsAngle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_setMotorsAngle,
                args1: [{
                    type: "input_value",
                    name: "ANGLE"
                }, {
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.HRCUMOTION_ARG_LEFTTURN, "左转"],
                        [ScratchBlocks.Msg.HRCUMOTION_ARG_RIGHTTURN, "右转"]
                    ]
                }, {
                    type: "input_value",
                    name: "TIME"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_motion_stopMotorRun = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_STOPMOTORRUN,
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_motion_setOneCircleSize = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/db_move.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUMOTION_setOneCircleSize,
                args1: [{
                    type: "input_value",
                    name: "LENGTH"
                }],
                colour: "#fccf06",
                colourSecondary: "#fccf06",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };




    ScratchBlocks.Blocks.E7_sensor_getTouch = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/chu_peng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getTouch,
                args1: [{
                    type: "field_dropdown",
                    name: "SENSORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_PRESS, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_LOOSE, "0"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_isUltra = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/chao_shen_bo.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_ISULTRA,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        [">", ">"],
                        ["<", "<"],
                        ["=", "="]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_isElectedData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/guan_dian.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_ISELECTEDDATA,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        [">", ">"],
                        ["<", "<"],
                        ["=", "="]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_isColor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/RGB.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_ISCOLOR,
                args1: [{
                    type: "field_dropdown",
                    name: "SENSORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_RED, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_GREEN, "2"],
                        [ScratchBlocks.Msg.SENSOR_ARG_BLUE, "3"],
                        [ScratchBlocks.Msg.SENSOR_ARG_YELLOW, "4"],
                        [ScratchBlocks.Msg.SENSOR_ARG_BLACK, "5"],
                        [ScratchBlocks.Msg.SENSOR_ARG_WHITE, "6"],
                        [ScratchBlocks.Msg.SENSOR_ARG_ORANGE, "7"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_sensor_getUltrasonic = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/chao_shen_bo.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getUltrasonic,
                args1: [{
                    type: "field_dropdown",
                    name: "ULTRASONICPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_sensor_getLightSensor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/guan_dian.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: "%1 %2",
                args1: [{
                    type: "field_dropdown",
                    name: "SENSORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_VALUE, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_THRESHOLD, "2"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_sensor_colorDetection = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/RGB.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: "%1 %2",
                args1: [{
                    type: "field_dropdown",
                    name: "COLORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLORMODE",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_COLOR, "颜色"],
                        [ScratchBlocks.Msg.SENSOR_ARG_R_VLAUE, "R值"],
                        [ScratchBlocks.Msg.SENSOR_ARG_G_VLAUE, "G值"],
                        [ScratchBlocks.Msg.SENSOR_ARG_B_VLAUE, "B值"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };





    ScratchBlocks.Blocks.sensor_setElcLightIfData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/guan_dian.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_SETELELIGHTIFDATA,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#4bb4ff",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.E7_sensor_setColorLamp = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/cai_deng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_setColorLamp,
                args1: [{
                    type: "field_dropdown",
                    name: "SENSORPORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }],
                colour: ScratchBlocks.Colours.sensor.secondary,
                colourSecondary: ScratchBlocks.Colours.sensor.secondary,
                colourTertiary: ScratchBlocks.Colours.sensor.tertiary,
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_waitNewColor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/RGB.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_WAITNEWCOLOR,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: ["colours_sensor"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_waitThisColor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/RGB.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_WAITTHISCOLOR,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_RED, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_GREEN, "2"],
                        [ScratchBlocks.Msg.SENSOR_ARG_BLUE, "3"],
                        [ScratchBlocks.Msg.SENSOR_ARG_YELLOW, "4"],
                        [ScratchBlocks.Msg.SENSOR_ARG_BLACK, "5"],
                        [ScratchBlocks.Msg.SENSOR_ARG_WHITE, "6"],
                        [ScratchBlocks.Msg.SENSOR_ARG_ORANGE, "7"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: ["colours_sensor"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_sensor_setLightByRGB = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/cai_deng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_setLightByRGB,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "input_value",
                    name: "R"
                }, {
                    type: "input_value",
                    name: "G"
                }, {
                    type: "input_value",
                    name: "B"
                }],
                category: ScratchBlocks.Categories.sensor,
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: ["colours_sensor"]
            })
        }
    };



    ScratchBlocks.Blocks.E7_getAttitudeData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getAttitudeData,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        // ["偏航角", "偏航角"],
                        [ScratchBlocks.Msg.SENSOR_ARG_ROLLANGLE, "横滚角"],
                        [ScratchBlocks.Msg.SENSOR_ARG_PITCHANGLE, "俯视角"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getAccData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getAccData,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        ["X", "X"],
                        ["Y", "Y"],
                        ["Z", "Z"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getMagneticData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: "地磁 %1",
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        ["X", "X"],
                        ["Y", "Y"],
                        ["Z", "Z"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getGyroscopeData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getGyroscopeData,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        ["X", "X"],
                        ["Y", "Y"],
                        ["Z", "Z"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getTempAndHumData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/wen_shi_du.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SENSOR_getTempAndHumData,
                args1: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        ["P1", "1"],
                        ["P2", "2"],
                        ["P3", "3"],
                        ["P4", "4"],
                        ["P5", "5"],
                        ["P6", "6"],
                        ["P7", "7"],
                        ["P8", "8"],
                        ["P9", "9"],
                        ["P10", "10"],
                        ["P11", "11"],
                        ["P12", "12"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_TEMPERATURE, "0"],
                        [ScratchBlocks.Msg.SENSOR_ARG_HUMIDNESS, "1"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    // E7通讯模块

    ScratchBlocks.Blocks.hrcu_iot_initIot = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUIOT_INITIOT,
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_isIotDeviceData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUIOT_isIotDeviceData,
                args1: [{
                        type: "field_dropdown",
                        name: "IOTLIST",
                        options: () => {
                            let json = store.getState().scratchGui.downloadAlert.JSON_VALUE['setIsIotDevices']
                            let data = [
                                ["", ""]
                            ]
                            try {
                                if (json) {
                                    if (json.data.length > 0) {
                                        data = json.data.map((item) => {
                                            return [item, item]
                                        })
                                    }
                                }
                            } catch (err) {
                                console.log(err)
                            } finally {
                                return data
                            }
                        }
                    },
                    {
                        type: "input_value",
                        name: "VALUE"
                    }
                ],
                colour: "#00d7b1",
                extensions: ["output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_getIotDeviceData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUIOT_getIotDeviceData,
                args1: [{
                    type: "field_dropdown",
                    name: "IOTLIST",
                    options: () => {
                        let json = store.getState().scratchGui.downloadAlert.JSON_VALUE['setIsIotDevices']
                        let data = [
                            ["", ""]
                        ]
                        try {
                            if (json) {
                                if (json.data.length > 0) {
                                    data = json.data.map((item) => {
                                        return [item, item]
                                    })
                                }
                            }
                        } catch (err) {
                            console.log(err)
                        } finally {
                            return data
                        }
                    }
                }],
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_setIotDeviceData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUIOT_setIotDeviceData,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }, {
                    type: "field_dropdown",
                    name: "IOTLIST",
                    options: () => {
                        let json = store.getState().scratchGui.downloadAlert.JSON_VALUE['setIsIotDevices']
                        let data = [
                            ["", ""]
                        ]
                        try {
                            if (json) {
                                if (json.data.length > 0) {
                                    data = json.data.map((item) => {
                                        return [item, item]
                                    })
                                }
                            }
                        } catch (err) {
                            console.log(err)
                        } finally {
                            return data
                        }
                    }
                }],
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };



    ScratchBlocks.Blocks.hrcu_iot_resetIotResult = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUIOT_resetIotResult,
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_setWifiData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_setWifiData,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.hrcu_iot_getWifiData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_getWifiData,
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_setRcuBluetoothData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_setRcuBluetoothData,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.hrcu_iot_getRcuBluetoothData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_getRcuBluetoothData,
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_communication_GetPhoneWiFiYGData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_GetPhoneWiFiYGData,
                args1: [{
                    type: "field_dropdown",
                    name: "DIRECTION",
                    options: [
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_LEFT, "左"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_RIGHT, "右"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_X_AXIS, "X轴"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_Y_AXIS, "Y轴"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_AXIS, "与Y轴正方向的夹角"]
                    ]
                }],
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };



    ScratchBlocks.Blocks.hrcu_communication_IsPhoneWiFiBtnData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_IsPhoneWiFiBtnData,
                args1: [{
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        ["A", "A"],
                        ["B", "B"],
                        ["X", "X"],
                        ["Y", "Y"],
                    ]
                }],
                colour: "#00d7b1",
                extensions: ["output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_communication_IsPhoneWiFiYGData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_IsPhoneWiFiYGData,
                args1: [{
                    type: "field_dropdown",
                    name: "DIRECTION",
                    options: [
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_LEFT, "左"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_RIGHT, "右"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION1, "上"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION2, "左"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION3, "下"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION4, "右"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION5, "左上"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION6, "右上"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION7, "左下"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_DIRECTION8, "右下"],
                    ]
                }],
                colour: "#00d7b1",
                extensions: ["output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_communication_OpenCameraForPhone = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_OpenCameraForPhone,
                args1: [{
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_ON, "开启"],
                        [ScratchBlocks.Msg.HRCUWIFI_ARG_OFF, "关闭"]
                    ]
                }],
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_communication_SendWifiBtnDescribe = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.HRCUWIFI_SendWifiBtnDescribe,
                args1: [{
                    type: "field_dropdown",
                    name: "BTN",
                    options: [
                        ["A", "A"],
                        ["B", "B"],
                        ["C", "C"],
                        ["D", "D"]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_startCamera = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_STARTCAMERA,
                args1: [{
                    type: "field_dropdown",
                    name: "START",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_START, "运行"],
                        [ScratchBlocks.Msg.AI_ARG_STOP, "关闭"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "FNNAME",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM1, "人脸识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM12, "道路识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM7, "人脸追踪"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM2, "物体追踪"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM3, "交通标志识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM4, "垃圾分类识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM5, "常见物体识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM6, "剪刀石头布"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM8, "姿态识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM9, "二维码识别"],
                        [ScratchBlocks.Msg.AI_ARG_ALGORITHM11, "黑线识别"]
                    ]
                }],
                colour: "#DA70D6",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }


    ScratchBlocks.Blocks.AI_setFaceRegister = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_SETFACEREGISTER,
                args1: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: "#DA70D6",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.AI_getZxing = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_GETZXING,
                category: ScratchBlocks.Categories.ai,
                extensions: ["colours_ai", "output_number"]
            })
        }
    }




    ScratchBlocks.Blocks.AI_getBlackLineData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_GETBLACKLINEDATA,
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_GetRoadAngle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_GETROADANGLE,
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_getPoseData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_getPoseData,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG1_getPoseData, "挥手（左）"],
                        [ScratchBlocks.Msg.AI_ARG2_getPoseData, "挥手（右）"],
                        [ScratchBlocks.Msg.AI_ARG3_getPoseData, "跑步"],
                        [ScratchBlocks.Msg.AI_ARG4_getPoseData, "开合跳"],
                        [ScratchBlocks.Msg.AI_ARG5_getPoseData, "划动（手）"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_setStartMF = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.AI_SETSTARTMF,
                args0: [{
                    type: "field_dropdown",
                    name: "VALUE",
                    options: [
                        [ScratchBlocks.Msg.AI_getPoseData_ARG_START, "开始"],
                        [ScratchBlocks.Msg.AI_getPoseData_ARG_STOP, "停止"]
                    ]
                }],
                colour: "#DA70D6",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    }


    ScratchBlocks.Blocks.AI_getMFColor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.AI_GETMFCOLOR,
                args0: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.AI_getWeather = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/tian_qi.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_GETWEATHER,
                args1: [{
                    type: "input_value",
                    name: "city"
                }, {
                    type: "field_dropdown",
                    name: "type",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER1, "全部数据"],
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER2, "天气"],
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER3, "温度"],
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER4, "湿度"],
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER5, "风向"],
                        [ScratchBlocks.Msg.AI_ARG_GETWEATHER6, "风力"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.AI_getAiData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_GETAIDATA,
                args1: [{
                    type: "field_dropdown",
                    name: "DATA",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG1_getAiData, "ID"],
                        [ScratchBlocks.Msg.AI_ARG2_getAiData, "中心X坐标"],
                        [ScratchBlocks.Msg.AI_ARG3_getAiData, "中心Y坐标"],
                        [ScratchBlocks.Msg.AI_ARG4_getAiData, "宽度"],
                        [ScratchBlocks.Msg.AI_ARG5_getAiData, "高度"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.AI_SetCameraShow = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_SetCameraShow,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.AI_SetCameraShow_ARG_SHOW, "1"],
                        [ScratchBlocks.Msg.AI_SetCameraShow_ARG_HIDE, "0"],
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };

    
    ScratchBlocks.Blocks.AI_getSimplePoseList = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.AI_GETSIMPLEPOSELIST,
                args0: [{
                    type: "field_dropdown",
                    name: "PART",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST1, "左手腕"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST2, "右手腕"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST3, "左手肘"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST4, "右手肘"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST5, "左肩膀"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST6, "右肩膀"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST7, "头"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST8, "左膝盖"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST9, "右膝盖"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST10, "左脚腕"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST11, "右脚腕"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COORDINATE",
                    options: [
                        [ScratchBlocks.Msg.AI_X, "x坐标"],
                        [ScratchBlocks.Msg.AI_Y, "y坐标"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.E7_setTTS = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_setTTS,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#DA70D6",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: ["shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_setAiResult = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/zi_neng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AI_SETAIRESULT,
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.AI_getMfByBt = {
        init: function () {
            this.jsonInit({
                message0: "获取蓝牙魔方数据",
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_isMfConnect = {
        init: function () {
            this.jsonInit({
                message0: "魔方是否连接？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_isHandShock = {
        init: function () {
            this.jsonInit({
                message0: "是否摆臂？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.AI_isMfFinish = {
        init: function () {
            this.jsonInit({
                message0: "魔方是否复位？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_runNext = {
        init: function () {
            this.jsonInit({
                message0: "执行魔方下一步",
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_searchMf = {
        init: function () {
            this.jsonInit({
                message0: "搜索解魔方步骤",
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_startMFColor = {
        init: function () {
            this.jsonInit({
                message0: "识别魔方颜色 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "NUM",
                    options: [
                        ["1", "1"],
                        ["2", "2"],
                        ["3", "3"],
                        ["4", "4"],
                        ["5", "5"],
                        ["6", "6"],
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_getRunSpeed = {
        init: function () {
            this.jsonInit({
                message0: "人体姿态是否抬腿",
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.AI_getForecastTrue = {
        init: function () {
            this.jsonInit({
                message0: "未命名模型：预测特征1 %1 特征2 %2 特征3 %3 特征4 %4 的置信度",
                args0: [{
                    type: "input_value",
                    name: "ARG1"
                }, {
                    type: "input_value",
                    name: "ARG2"
                }, {
                    type: "input_value",
                    name: "ARG3"
                }, {
                    type: "input_value",
                    name: "ARG4"
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_getForecastType = {
        init: function () {
            this.jsonInit({
                message0: "未命名模型：预测特征1 %1 特征2 %2 特征3 %3 特征4 %4 的分类",
                args0: [{
                    type: "input_value",
                    name: "ARG1"
                }, {
                    type: "input_value",
                    name: "ARG2"
                }, {
                    type: "input_value",
                    name: "ARG3"
                }, {
                    type: "input_value",
                    name: "ARG4"
                }],
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_startBDApi = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/ai_yun.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AICLOUD_startBDApi,
                args1: [{
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_START, "运行"],
                        [ScratchBlocks.Msg.AI_ARG_STOP, "关闭"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_getVoiceData = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/ai_yun.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AICLOUD_getVoiceData,
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.AI_getTextRecognizeResult = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/ai_yun.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AICLOUD_getTextRecognizeResult,
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_setTextRecognize = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/ai_yun.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AICLOUD_setTextRecognize,
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_startBDVoiceRecognize = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/ai_yun.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.AICLOUD_startBDVoiceRecognize,
                args1: [{
                    type: "input_value",
                    name: "TIME"
                }],
                colour: "#DA70D6",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getIsTouch = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_GET_TOUCHSCREEN,
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_GetTouchScreenXY = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_GetTouchScreenXY,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST_POSITION1, "X轴"],
                        [ScratchBlocks.Msg.AI_ARG_GETSIMPLEPOSELIST_POSITION2, "Y轴"]
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_LCDClearScreen = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_LCDCLEARSCREEN,
                args1: [{
                    type: "field_dropdown",
                    name: "COLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_SetFontSize = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_SETFONTSIZE,
                args1: [{
                    type: "field_dropdown",
                    name: "FONTSIZE",
                    defaultItem: 0,
                    options: [
                        [ScratchBlocks.Msg.JMD_FONTSIZE1, "0"],
                        [ScratchBlocks.Msg.JMD_FONTSIZE2, "1"],
                        [ScratchBlocks.Msg.JMD_FONTSIZE3, "2"],
                        [ScratchBlocks.Msg.JMD_FONTSIZE4, "3"],
                        [ScratchBlocks.Msg.JMD_FONTSIZE5, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_setPaintColor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_SETPAINTCOLOR,
                args1: [{
                    type: "field_dropdown",
                    name: "COLOR",
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                colour: "#8dca5d",
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.E7_setAlpha = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_SETALPHA,
                args1: [{
                    type: "input_value",
                    name: "DATA"
                }],
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_setZxing = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_SETZXING,
                args1: [{
                    type: "input_value",
                    name: "DATA",
                }],
                category: ScratchBlocks.Categories.ai,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    }

    ScratchBlocks.Blocks.E7_setDisplayStringXYS = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_setDisplayStringXYS,
                args1: [{
                    type: "input_value",
                    name: "X",
                }, {
                    type: "input_value",
                    name: "Y",
                }, {
                    type: "input_value",
                    name: "TEXT",
                }],
                colour: "#8dca5d",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.E7_setColor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_SET_COLOR,
                args1: [{
                    type: "input_value",
                    name: "LINES"
                }, {
                    type: "input_value",
                    name: "TEXT"
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_drawImage = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_drawImage,
                args1: [{
                    type: "input_value",
                    name: "IMAGEX"
                }, {
                    type: "input_value",
                    name: "IMAGEY"
                }, {
                    type: "input_value",
                    name: "IMAGEFILENAME"
                }, {
                    type: "input_value",
                    name: "IMAGESCALE"
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_drawPoint = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_DRAW_POINt,
                args1: [{
                    type: "input_value",
                    name: "POINTX"
                }, {
                    type: "input_value",
                    name: "POINTY"
                }, {
                    type: "field_dropdown",
                    name: "POINTCOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_drawLine = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_DRAW_LINE,
                args1: [{
                    type: "input_value",
                    name: "LINEX"
                }, {
                    type: "input_value",
                    name: "LINEY"
                }, {
                    type: "input_value",
                    name: "LINEANGLE"
                }, {
                    type: "input_value",
                    name: "LINELENGTH"
                }, {
                    type: "field_dropdown",
                    name: "LINECOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_drawCircle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_DRAW_CIRCLE,
                args1: [{
                    type: "input_value",
                    name: "CIRCLEX"
                }, {
                    type: "input_value",
                    name: "CIRCLEY"
                }, {
                    type: "input_value",
                    name: "CIRCLERADIUS"
                }, {
                    type: "field_dropdown",
                    name: "CIRCLECOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_drawRectangle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_DRAW_RECTANGLE,
                args1: [{
                    type: "input_value",
                    name: "RECTANGLEX"
                }, {
                    type: "input_value",
                    name: "RECTANGLEY"
                }, {
                    type: "input_value",
                    name: "RECTANGLEWIDTH"
                }, {
                    type: "input_value",
                    name: "RECTANGLEHEIGHT"
                }, {
                    type: "input_value",
                    name: "RECTANGLELINEWIDTH"
                }, {
                    type: "field_dropdown",
                    name: "RECTANGLECOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_drawSolidRectangle = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.SHOW_DRAW_SOLIDRECTANGLE,
                args1: [{
                    type: "input_value",
                    name: "SOLIDRECTANGLEX"
                }, {
                    type: "input_value",
                    name: "SOLIDRECTANGLEY"
                }, {
                    type: "input_value",
                    name: "SOLIDRECTANGLEWIDTH"
                }, {
                    type: "input_value",
                    name: "SOLIDRECTANGLEHEIGHT"
                }, {
                    type: "field_dropdown",
                    name: "SOLIDRECTANGLECOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.play_startMp3ByPai = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_STARTMP3BYPAI,
                args1: [{
                    type: "field_dropdown",
                    name: "NOTE",
                    options: [
                        ["Do", "Do"],
                        ["Re", "Re"],
                        ["Mi", "Mi"],
                        ["Fa", "Fa"],
                        ["So", "So"],
                        ["La", "La"],
                        ["Si", "Si"],
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE",
                }],
                colour: "#6b7fff",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.play_startMp3ByPath = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_STARTMP3BYPATH,
                args1: [{
                    type: "input_value",
                    name: "VALUE",
                }],
                colour: "#6b7fff",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };


    ScratchBlocks.Blocks.play_waitMp3ByPath = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_waitMp3ByPath,
                args1: [{
                    type: "input_value",
                    name: "VALUE",
                }],
                colour: "#6b7fff",
                inputsInline: true,
                previousStatement: null,
                nextStatement: null,
                extensions: []
            })
        }
    };
    ScratchBlocks.Blocks.E7_pausePlayback = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_pausePlayback,
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_playVoiceByName = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_playVoiceByName,
                args1: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        [ScratchBlocks.Msg.PLAY_music_drumSnare, "1"],
                        [ScratchBlocks.Msg.PLAY_music_drumBass, "2"],
                        [ScratchBlocks.Msg.PLAY_music_drumSideStick, "3"],
                        [ScratchBlocks.Msg.PLAY_music_drumCrashCymbal, "4"],
                        [ScratchBlocks.Msg.PLAY_music_drumOpenHiHat, "5"],
                        [ScratchBlocks.Msg.PLAY_music_drumClosedHiHat, "6"],
                        [ScratchBlocks.Msg.PLAY_music_drumTambourine, "7"],
                        [ScratchBlocks.Msg.PLAY_music_drumHandClap, "8"],
                        [ScratchBlocks.Msg.PLAY_music_drumClaves, "9"],
                        [ScratchBlocks.Msg.PLAY_music_drumWoodBlock, "10"],
                        [ScratchBlocks.Msg.PLAY_music_drumCowbell, "11"],
                        [ScratchBlocks.Msg.PLAY_music_drumTriangle, "12"],
                        [ScratchBlocks.Msg.PLAY_music_drumBongo, "13"],
                        [ScratchBlocks.Msg.PLAY_music_drumConga, "14"],
                        [ScratchBlocks.Msg.PLAY_music_drumCabasa, "15"],
                        [ScratchBlocks.Msg.PLAY_music_drumGuiro, "16"],
                        [ScratchBlocks.Msg.PLAY_music_drumVibraslap, "17"],
                        [ScratchBlocks.Msg.PLAY_music_drumCuica, "18"]
                    ]
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_startRecord = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_startRecord,
                args1: [{
                    type: "input_value",
                    name: "TIME"
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E7_playRecord = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_playRecord,
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E7_addVoiceSpeed = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_addVoiceSpeed,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_setVoiceSpeed = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_setVoiceSpeed,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getVoiceSpeed = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_getVoiceSpeed,
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "output_number"]
            })
        }
    };



    ScratchBlocks.Blocks.E7_addVoiceValue = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_addVoiceValue,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_setVoiceValue = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_setVoiceValue,
                args1: [{
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getVoiceValue = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_getVoiceValue,
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.E7_stopAllVoice = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.PLAY_stopAllVoice,
                category: ScratchBlocks.Categories.play,
                extensions: ["colours_play", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_event_ultrasonic = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/chao_shen_bo.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.EVENTS_ultrasonic,
                args1: [{
                        type: "field_dropdown",
                        name: "PORT",
                        options: [
                            ["P1", "1"],
                            ["P2", "2"],
                            ["P3", "3"],
                            ["P4", "4"],
                            ["P5", "5"],
                            ["P6", "6"],
                            ["P7", "7"],
                            ["P8", "8"],
                            ["P9", "9"],
                            ["P10", "10"],
                            ["P11", "11"],
                            ["P12", "12"]
                        ]
                    },
                    {
                        type: "field_dropdown",
                        name: "STATUS",
                        options: [
                            [ScratchBlocks.Msg.EVENTS_ARG_GT, ">"],
                            [ScratchBlocks.Msg.EVENTS_ARG_LT, "<"],
                            [ScratchBlocks.Msg.EVENTS_ARG_ET, "=="]
                        ]
                    },
                    {
                        type: "input_value",
                        name: "VALUE"
                    }
                ],
                extensions: ["colours_event", "shape_hat"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_event_colorSensor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/RGB.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.EVENTS_colorSensor,
                args1: [{
                        type: "field_dropdown",
                        name: "PORT",
                        options: [
                            ["P1", "1"],
                            ["P2", "2"],
                            ["P3", "3"],
                            ["P4", "4"],
                            ["P5", "5"],
                            ["P6", "6"],
                            ["P7", "7"],
                            ["P8", "8"],
                            ["P9", "9"],
                            ["P10", "10"],
                            ["P11", "11"],
                            ["P12", "12"]
                        ]
                    },
                    {
                        type: "field_dropdown",
                        name: "COLOR",
                        options: [
                            [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                            [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                            [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                            [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                            [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                            [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                            [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                            [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                        ]
                    }
                ],
                extensions: ["colours_event", "shape_hat"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_event_touchSensor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/chu_peng.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.EVENTS_touchSensor,
                args1: [{
                        type: "field_dropdown",
                        name: "PORT",
                        options: [
                            ["P1", "1"],
                            ["P2", "2"],
                            ["P3", "3"],
                            ["P4", "4"],
                            ["P5", "5"],
                            ["P6", "6"],
                            ["P7", "7"],
                            ["P8", "8"],
                            ["P9", "9"],
                            ["P10", "10"],
                            ["P11", "11"],
                            ["P12", "12"]
                        ]
                    },
                    {
                        type: "field_dropdown",
                        name: "STATUS",
                        options: [
                            [ScratchBlocks.Msg.EVENTS_ARG_PRESS, "True"],
                            [ScratchBlocks.Msg.EVENTS_ARG_COOLSE, "False"]
                        ]
                    }
                ],
                extensions: ["colours_event", "shape_hat"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_event_voiceSensor = {
        init: function () {
            this.jsonInit({
                message0: "%1 %2",
                args0: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/rcu.svg",
                    width: 30,
                    height: 26

                }, {
                    type: "field_vertical_separator"
                }],
                message1: ScratchBlocks.Msg.EVENTS_voiceSensor,
                args1: [{
                        type: "field_dropdown",
                        name: "STATUS",
                        options: [
                            [ScratchBlocks.Msg.EVENTS_ARG_GT, ">"],
                            [ScratchBlocks.Msg.EVENTS_ARG_LT, "<"],
                            [ScratchBlocks.Msg.EVENTS_ARG_ET, "=="]
                        ]
                    },
                    {
                        type: "input_value",
                        name: "VALUE"
                    }
                ],
                extensions: ["colours_event", "shape_hat"]
            })
        }
    };

    

    ScratchBlocks.Blocks.pid_setPidControler = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.PID_SETPIDCONTROLER,
                args0: [{
                    type: "field_variable",
                    name: "PID",
                    variableTypes: ["PID"]
                }, {
                    type: "input_value",
                    name: "TARGET"
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                colour: "#20c5d4",
                colourSecondary: "#20c5d4",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.pid_setPidControlerFork = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.PID_SETPIDCONTROLERFORK,
                args0: [{
                    type: "field_variable",
                    name: "PID",
                    variableTypes: ["PID"]
                }, {
                    type: "input_value",
                    name: "KP"
                }, {
                    type: "input_value",
                    name: "KI"
                }, {
                    type: "input_value",
                    name: "KD"
                }],
                colour: "#20c5d4",
                colourSecondary: "#20c5d4",
                extensions: ["shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.pid_getPidControlResult = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.PID_GETPIDCONTROLRESULT,
                args0: [{
                    type: "field_variable",
                    name: "PID",
                    variableTypes: ["PID"]
                }],
                colour: "#20c5d4",
                colourSecondary: "#20c5d4",
                extensions: ["output_number"]
            })
        }
    };



    ScratchBlocks.Blocks.operator_isStringSame = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.OPERATORS_ISSTRINGSAME,
                args0: [{
                    type: "input_value",
                    name: "string_one"
                }, {
                    type: "input_value",
                    name: "string_two"
                }],
                colour: "#59c059",
                extensions: ["output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.operator_fotmatToFloat = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.OPERATORS_FOTMATTOFLOAT,
                args0: [{
                    "type": "input_value",
                    "name": "STR"
                }],
                inputsInline: true,
                output: "Number",
                colour: "#59c059",
                extensions: ["output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.operator_getStringFormat = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.OPERATORS_getStringFormat,
                args0: [{
                    type: "input_value",
                    name: "string_one",
                }, {
                    type: "input_value",
                    name: "string_two",
                }],
                colour: '#00afae',
                extensions: ["colours_operators", "output_number"]
            })
        }
    }


    ScratchBlocks.Blocks.control_stopPy = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.CONTROL_STOPPY,
                args0: [{
                    type: "field_dropdown",
                    name: "CMD",
                    options: [
                        [ScratchBlocks.Msg.CONTROL_ARG_STOPEXIT, "停止并退出程序"],
                        [ScratchBlocks.Msg.CONTROL_ARG_STOPTASK, "停止此任务"],
                        [ScratchBlocks.Msg.CONTROL_ARG_STOPALLTASK, "停止所有"]
                    ]
                }],
                previousStatement: null,
                extensions: ["colours_control"]
            })
        }
    };

}
